// import React from 'react';
// import { ChevronLeft, Building2, User, Calendar, Users, ShieldCheck } from 'lucide-react';

// const ClubDetails = ({ club, onBack, styles }) => {
//   const SectionHeader = ({ title }) => (
//     <div style={{ backgroundColor: '#FFC20E', padding: '8px 15px', borderRadius: '8px 8px 0 0', marginTop: '15px' }}>
//       <span style={{ fontSize: '12px', fontWeight: 'bold', color: 'white', textTransform: 'uppercase' }}>{title}</span>
//     </div>
//   );

//   const DetailItem = ({ icon: Icon, label, value, isLast }) => (
//     <div style={{ display: 'flex', alignItems: 'center', padding: '12px 15px', borderBottom: isLast ? 'none' : '1px solid #f0f0f0' }}>
//       <div style={{ backgroundColor: '#E8EEFB', color: '#0033A0', padding: '8px', borderRadius: '50%', marginRight: '15px' }}>
//         <Icon size={18} />
//       </div>
//       <div style={{ display: 'flex', flexDirection: 'column' }}>
//         <span style={{ fontSize: '12px', color: '#888' }}>{label}</span>
//         <span style={{ fontSize: '14px', color: '#0033A0', fontWeight: '500' }}>{value}</span>
//       </div>
//     </div>
//   );

//   return (
//     <div style={styles.scrollArea}>
//       {/* Blue Header Section */}
//       <div style={{ backgroundColor: '#0033A0', color: 'white' }}>
//         <div style={{ padding: '15px', display: 'flex', alignItems: 'center', gap: '15px' }}>
//           <ChevronLeft onClick={onBack} style={{ cursor: 'pointer' }} />
//           <h2 style={{ fontSize: '18px', margin: 0 }}>Club Details</h2>
//         </div>
//         <div style={{ padding: '20px 15px' }}>
//           <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '8px' }}>
//             <Building2 size={28} />
//             <h1 style={{ fontSize: '24px', margin: 0 }}>{club.name}</h1>
//           </div>
//           <div style={{ display: 'flex', alignItems: 'center', gap: '5px', fontSize: '13px', opacity: 0.8 }}>
//             <Users size={14} /> 45 Active Members
//           </div>
//         </div>
//       </div>

//       <div style={{ padding: '0 15px 20px' }}>
//         {/* Basic Information */}
//         <SectionHeader title="Basic Information" />
//         <div style={{ backgroundColor: 'white', borderRadius: '0 0 8px 8px', border: '1px solid #eee' }}>
//           <DetailItem icon={User} label="Member ID" value="135057" />
//           <DetailItem icon={Building2} label="Club Name" value={club.name} />
//           <DetailItem icon={Calendar} label="Chartered On" value="January 15, 2010" />
//           <DetailItem icon={Users} label="Total Members" value="45" isLast />
//           <div style={{ padding: '15px', borderTop: '1px solid #f0f0f0' }}>
//              <span style={{ fontSize: '12px', color: '#888', display: 'block' }}>Sponsored By</span>
//              <span style={{ fontSize: '14px', color: '#0033A0' }}>Lions Club International Foundation</span>
//           </div>
//         </div>

//         {/* Leadership */}
//         <SectionHeader title="Leadership" />
//         <div style={{ backgroundColor: 'white', borderRadius: '0 0 8px 8px', border: '1px solid #eee' }}>
//           <DetailItem icon={User} label="President" value="Lion John Doe" />
//           <DetailItem icon={User} label="Charter President" value="Lion Jane Smith" />
//           <DetailItem icon={User} label="Secretary" value="Lion Michael Brown" />
//           <DetailItem icon={User} label="Treasurer" value="Lion Sarah Johnson" isLast />
//         </div>

// //         {/* Chairpersons */}
//         <SectionHeader title="Chairpersons" />
//         <div style={{ backgroundColor: 'white', borderRadius: '0 0 8px 8px', border: '1px solid #eee' }}>
//           <DetailItem icon={User} label="Extension Chairperson" value="Lion Robert Williams" />
//           <DetailItem icon={User} label="Region Chairperson" value="Lion Patricia Davis" />
//           <DetailItem icon={User} label="Zone Chairperson" value="Lion James Wilson" isLast />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ClubDetails;

import React from 'react';
import { ChevronLeft, Building2, User, Calendar, Users, Club } from 'lucide-react';

const ClubDetails = ({ club, onBack, styles }) => {

  if (!club) return null;

  const SectionHeader = ({ title }) => (
    <div style={{ backgroundColor: '#FFC20E', padding: '8px 15px', borderRadius: '8px 8px 0 0', marginTop: '15px' }}>
      <span style={{ fontSize: '12px', fontWeight: 'bold', color: 'white', textTransform: 'uppercase' }}>
        {title}
      </span>
    </div>
  );

  const DetailItem = ({ icon: Icon, label, value, isLast }) => (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      padding: '12px 15px',
      borderBottom: isLast ? 'none' : '1px solid #f0f0f0'
    }}>
      <div style={{
        backgroundColor: '#E8EEFB',
        color: '#0033A0',
        padding: '8px',
        borderRadius: '50%',
        marginRight: '15px'
      }}>
        <Icon size={18} />
      </div>

      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <span style={{ fontSize: '12px', color: '#888' }}>{label}</span>
        <span style={{ fontSize: '14px', color: '#0033A0', fontWeight: '500' }}>
          {value || '-'}
        </span>
      </div>
    </div>
  );

  console.log("Club",club)

  return (
    <div style={styles.scrollArea}>

      {/* Header */}
      <div style={{ backgroundColor: '#0033A0', color: 'white' }}>
        <div style={{ padding: '15px', display: 'flex', alignItems: 'center', gap: '15px' }}>
          <ChevronLeft onClick={onBack} style={{ cursor: 'pointer' }} />
          <h2 style={{ fontSize: '18px', margin: 0 }}>Club Details</h2>
        </div>

        <div style={{ padding: '20px 15px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '8px' }}>
            <Building2 size={28} />
            <h1 style={{ fontSize: '24px', margin: 0 }}>
              {club.clubName}
            </h1>
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: '5px', fontSize: '13px', opacity: 0.8 }}>
            <Users size={14} /> {club.totalMembers || 0} Members
          </div>
        </div>
      </div>

      <div style={{ padding: '0 15px 20px' }}>

        {/* Basic Info */}
        <SectionHeader title="Basic Information" />
        <div style={{ backgroundColor: 'white', borderRadius: '0 0 8px 8px', border: '1px solid #eee' }}>
          <DetailItem icon={Building2} label="Club Name" value={club.clubName} />
          <DetailItem icon={User} label="Club Number" value={club.clubNumber} />
          <DetailItem icon={Calendar} label="Chartered Date" value={club.charteredDate} />
          <DetailItem icon={User} label="District" value={club.dist} isLast />
        </div>

        {/* Leadership */}
        <SectionHeader title="Leadership" />
        <div style={{ backgroundColor: 'white', borderRadius: '0 0 8px 8px', border: '1px solid #eee' }}>
          <DetailItem icon={User} label="President" value={club.president} />
          <DetailItem icon={User} label="Secretary" value={club.secretory} />
          <DetailItem icon={User} label="Treasurer" value={club.treasurer} isLast />
        </div>

                {/* Chairpersons */}
        <SectionHeader title="Chairpersons" />
        <div style={{ backgroundColor: 'white', borderRadius: '0 0 8px 8px', border: '1px solid #eee' }}>
          <DetailItem icon={User} label="Extension Chairperson" value={club.extnChairperson}/>
          <DetailItem icon={User} label="Region Chairperson" vvalue={club.regionChairperson} />
          <DetailItem icon={User} label="Zone Chairperson"value={club.zoneChairperson} isLast />
        </div>

      </div>
    </div>
  );
};

export default ClubDetails;